import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CompanyMinimalFragment,
  TemplateFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { DashboardIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type TemplateCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: TemplateFragment;
};

export function isTemplateCreatedActivity(
  q: ActivityFragment
): q is TemplateCreatedActivity {
  return q.key === "template.created";
}

interface TemplateCreatedActivityProps {
  activity: TemplateCreatedActivity;
}

export const TemplateCreatedActivity: React.FC<TemplateCreatedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="templateCreatedActivity"
        visual={<DashboardIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.templateCreated", {
            template: (
              <Link to={`/templates/${activity.trackable.slug}/edit`}>
                {activity.trackable.title}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
